class CampaignGrid {
    constructor(campaignsArray) {
        this.campaignsArray = campaignsArray;
    }
    renderCampaigns() {
        this.campaignsArray.forEach((element) => {
            $(".campaign-grid").append(
                $("<div>").attr({
                    'class': "grid-item swell-campaign-link",
                    'id': element.id,
                    'data-campaign-id': element.id,
                    'data-display-mode': "modal",
                    'href': "javascript:void(0)",
                    'style': `background-image: url('${element.backgroundImageUrl}')`
                }).append(
                    $('<div>').append(
                        $("<div>").append(
                            $("<p>").text(element.rewardPoints > 1 ? `${element.rewardPoints} POINTS` : "1 POINT").addClass('swell-points'),
                            $("<p>").text(element.title).addClass('swell-campaign-title')
                        ) //append icon element here
                    ).attr({
                        'class': 'campaign-info-container'
                    })
                ))
        })
    }
    static renderCampaignImage() {
        $("<div>").attr({
            class: "grid-item swell-campaign-link img-container",
            'style': `background-image: url('//2undr.co.uk/cdn/shop/t/15/assets/swell-rewards-campaign-img.jpg?v=10552509563285189571625127067')`
        }).append(
            $("<div>").addClass('campaign-info-container')
            .append(
                $("<img>").attr({
                    'class': 'logo-container',
                    'src': `//2undr.co.uk/cdn/shop/t/15/assets/swell-2UNDR-logo.png?v=11836410400733705701625127058`
                })
            )
        ).insertAfter(".grid-item:last-child");
    }
}